export default "__VITE_ASSET__B10y0xKn__"